import React from "react";
import moment from "moment";
import {
  Modal,
  Form,
  InputNumber,
  Input,
  Button,
  Select,
  DatePicker,
} from "antd";
import { ModalProps } from "antd/es/modal";
import * as service from "../service";
const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};
const validateMessages = {
  required: "${label} 必填项!",
};
const commonStyle = {
  width: 250,
};

const CreateEditModal = ({ onSubmit, onClose, modalProps, initData = {} }) => {
  const [form] = Form.useForm();
  const [confirmLoading, changeConfirmLoading] = React.useState(false);
  const [formValues, changeFormValues] = React.useState({ activityType: 1 });
  const [visible, changeVisible] = React.useState(true);
  const [modalType, changeModalType] = React.useState("create");
  React.useEffect(() => {
    if (visible) {
      if (initData.id) {
        changeModalType("edit");
        const currFormValues = {
          ...initData,
          startTime:
            initData.startTime &&
            moment(initData.startTime, "YYYY-MM-DD HH:mm:ss"),
          endTime:
            initData.startTime &&
            moment(initData.endTime, "YYYY-MM-DD HH:mm:ss"),
        };
        changeFormValues(currFormValues);
        form.setFieldsValue(currFormValues);
      }
    }
  }, [visible]);
  const handleSubmit = async () => {
    const values = await form.validateFields();
    const params = {
      ...values,
      startTime: values.startTime
        .startOf("minute")
        .format("YYYY-MM-DD HH:mm:ss"),
      endTime: values.endTime.startOf("minute").format("YYYY-MM-DD HH:mm:ss"),
    };
    if (modalType === "edit") {
      params.id = initData.id;
    }
    changeConfirmLoading(true);
    const res = await service.createEditActivity(params);
    changeConfirmLoading(false);
    onSubmit(res);
    if (res && res.data) {
      handleCancel();
    }
  };

  const handleCancel = () => {
    changeVisible(false);
    onClose();
  };
  return (
    <Modal
      title={modalType === "edit" ? "编辑活动" : "新增活动"}
      visible={visible}
      onCancel={handleCancel}
      width={700}
      onOk={handleSubmit}
      confirmLoading={confirmLoading}
      {...modalProps}
    >
      <Form
        {...layout}
        name="nest-messages"
        validateMessages={validateMessages}
        form={form}
        onValuesChange={(currentValue, allValues) => {
          changeFormValues(allValues);
        }}
        initialValues={formValues}
      >
        <Form.Item
          name="activityName"
          label="活动名称"
          rules={[{ required: true }]}
        >
          <Input style={commonStyle} placeholder="请输入活动名称" />
        </Form.Item>
        <Form.Item
          name="activityDesc"
          label="活动简介"
          rules={[{ required: true }]}
        >
          <Input.TextArea
            style={commonStyle}
            placeholder="请输入活动简介"
            rows={3}
          />
        </Form.Item>
        <Form.Item
          name="activityType"
          label="活动类型"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="请选择活动类型"
            style={commonStyle}
            disabled={modalType === "edit"}
          >
            <Select.Option value={1}>订单总价满减</Select.Option>
            <Select.Option value={2}>订单单个商品折扣</Select.Option>
            <Select.Option value={3}>订单所有商品折扣</Select.Option>
          </Select>
        </Form.Item>
        {formValues.activityType === 1 && (
          <>
            <Form.Item
              name="totalPrice"
              label="总价满足（元）"
              rules={[{ required: true }]}
            >
              <InputNumber
                precision={2}
                min={0.01}
                max={9999.99}
                placeholder="请输入总价满足（元）"
                style={commonStyle}
                disabled={modalType === "edit"}
              />
            </Form.Item>
            <Form.Item
              name="reducePrice"
              label="满减（元）"
              rules={[{ required: true }]}
            >
              <InputNumber
                precision={2}
                min={0.01}
                max={9999.99}
                placeholder="请输入满减（元）"
                style={commonStyle}
                disabled={modalType === "edit"}
              />
            </Form.Item>
          </>
        )}
        {formValues.activityType !== 1 && (
          <>
            <Form.Item
              name="minNum"
              label="最小件数"
              rules={[{ required: true }]}
            >
              <InputNumber
                min={1}
                max={99}
                placeholder="请输入最小件数"
                style={commonStyle}
                disabled={modalType === "edit"}
              />
            </Form.Item>
            <Form.Item
              name="discount"
              label="活动折扣"
              rules={[{ required: true }]}
            >
              <InputNumber
                precision={2}
                min={0.01}
                max={0.99}
                placeholder="请输入活动折扣"
                style={commonStyle}
                disabled={modalType === "edit"}
              />
            </Form.Item>
          </>
        )}
        <Form.Item
          name="startTime"
          label="活动起始时间"
          rules={[{ required: true }]}
        >
          <DatePicker
            showTime
            placeholder="请输入活动起始时间"
            style={commonStyle}
            format="YYYY-MM-DD HH:mm"
            disabled={modalType === "edit"}
          />
        </Form.Item>
        <Form.Item
          name="endTime"
          label="活动结束时间"
          rules={[{ required: true }]}
        >
          <DatePicker
            showTime
            placeholder="请输入活动结束时间"
            style={commonStyle}
            format="YYYY-MM-DD HH:mm"
            disabled={modalType === "edit"}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateEditModal;
const { Option } = Select;
